<template>
	<v-main>
		<div style="display: flex; flex-direction: column; height: 100%">
			<v-row v-if="meeting.transitMap.isUseCometChat">
				<v-col :cols="!isMobile ? 3 : 12" class="d-flex flex-column pa-0" v-if="!isMobile || (isMobile && showConversation)">
					<v-card height="100%" elevation :style="{ backgroundColor: color.backgroundColor }" tile>
						<v-tabs v-model="mobileTab" dark show-arrows fixed-tabs v-if="isMobile">
							<v-tab v-for="(category, idxCategory) in tabMobileCategories" :key="idxCategory" @click="toTabMenu(category.content)">
								<v-badge :value="category.isBadgeOn">{{ category.tab }}</v-badge>
							</v-tab>
						</v-tabs>

						<v-tabs v-model="chatTab" :background-color="color.backgroundColor" dark show-arrows fixed-tabs>
							<v-tab v-for="(category, idxCategory) in chatCategories" :key="idxCategory">
								<v-badge :value="category.isBadgeOn" dot color="red">{{ category.tab }}</v-badge>
							</v-tab>
						</v-tabs>

						<v-tabs-items v-model="chatTab" style="background-color: rgba(0, 0, 0, 0)">
							<v-tab-item style="background-color: rgba(0, 0, 0, 0)">
								<v-card class="scrollable" flat style="background-color: rgba(0, 0, 0, 0)">
									<v-card-text>
										<v-list-item-group v-if="directMessages.length != 0" v-model="directMessageNumber" mandatory dark>
											<v-list-item
												class="chat"
												v-for="(directMessageNumber, i) in directMessages"
												:key="i"
												:class="i % 2 == 0 ? 'chatList1' : 'chatList2'"
												@click="
													(!isMobile && chatRoom.uid != directMessageNumber.conversationWith.uid) || isMobile
														? directMessageClicked(directMessageNumber)
														: ''
												"
											>
												<v-list-item-icon>
													<v-badge
														:content="directMessageNumber.unreadMessageCount"
														:value="directMessageNumber.unreadMessageCount"
														color="red"
														overlap
													>
														<v-avatar color="white">
															<v-img
																:src="profilePicture(directMessageNumber.conversationWith.uid)"
																@error="setAltImg"
															></v-img>
														</v-avatar>
													</v-badge>
												</v-list-item-icon>
												<v-list-item-content style="display: inline-block">
													<div>
														<v-row>
															<v-col cols="8">
																<v-list-item-title
																	v-text="directMessageNumber.conversationWith.name"
																></v-list-item-title>
															</v-col>
															<v-col cols="4">
																<span style="font-size: 12px; color: #bdbdbd">{{
																	formatDate(directMessageNumber.lastMessage.sentAt)
																}}</span>
															</v-col>
														</v-row>
														<v-row>
															<v-col cols="12" class="py-0 clamp">
																<span style>{{ directMessageNumber.lastMessage.text }}</span>
															</v-col>
														</v-row>
													</div>
												</v-list-item-content>
											</v-list-item>
										</v-list-item-group>
										<v-card v-else flat class="d-flex flex-column align-center pa-4" style="background-color: rgba(0, 0, 0, 0)"
											>No direct messages to show.</v-card
										>
									</v-card-text>
								</v-card>
							</v-tab-item>

							<v-tab-item style="background-color: rgba(0, 0, 0, 0)">
								<v-card class="scrollable" flat style="background-color: rgba(0, 0, 0, 0)">
									<v-card-text>
										<v-list-item-group v-if="chatRooms.length != 0" v-model="chatRoomNumber" mandatory dark>
											<v-list-item
												class="chat"
												v-for="(chatRoomNumber, i) in chatRooms"
												:key="i"
												:class="i % 2 == 0 ? 'chatList1' : 'chatList2'"
												@click="
													(!isMobile && chatRoom.guid != chatRoomNumber.guid) || isMobile
														? chatRoomClicked(chatRoomNumber)
														: ''
												"
											>
												<v-list-item-icon>
													<v-badge
														:content="chatRoomNumber.unreadMessageCount"
														:value="chatRoomNumber.unreadMessageCount"
														color="red"
														overlap
													>
														<v-avatar color="white">
															<v-icon color="#eb6e1f">mdi-account-group</v-icon>
														</v-avatar>
													</v-badge>
												</v-list-item-icon>

												<v-list-item-content>
													<v-list-item-title v-text="meeting.title"></v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list-item-group>
										<v-card v-else flat class="d-flex flex-column align-center pa-4" style="background-color: rgba(0, 0, 0, 0)"
											>No chat rooms to show.</v-card
										>
									</v-card-text>
								</v-card>
							</v-tab-item>
						</v-tabs-items>

						<v-dialog v-model="privateRoom.dialog" max-width="70%">
							<v-card>
								<v-card-title class="headline">Create Private Chat Room</v-card-title>

								<v-card-text>
									<v-form ref="privateRoomForm" v-model="privateRoom.validForm">
										<v-row class="pa-2">
											<v-text-field
												v-model="privateRoom.name"
												:rules="privateRoom.nameRules"
												outlined
												rounded
												counter
												maxlength="100"
												placeholder="Enter your chat room name"
											></v-text-field>
										</v-row>
										<v-row class="pa-2">
											<v-autocomplete
												v-model="privateRoom.toBeJoinedUsers"
												:items="allUsers"
												:rules="privateRoom.memberRules"
												filled
												chips
												color="#4e7c83"
												label="Select user to join chat"
												item-text="name"
												item-value="uid"
												multiple
											>
												<template v-slot:selection="data">
													<v-chip
														v-bind="data.attrs"
														:input-value="data.selected"
														close
														@click="data.select"
														@click:close="removeUser(data.item)"
														>{{ data.item.name }}</v-chip
													>
												</template>

												<template v-slot:item="data">
													<template v-if="typeof data.item !== 'object'">
														<v-list-item-content v-text="data.item"></v-list-item-content>
													</template>
													<template v-else>
														<v-list-item-content>
															<v-list-item-title v-html="data.item.name"></v-list-item-title>
														</v-list-item-content>
													</template>
												</template>
											</v-autocomplete>
										</v-row>
									</v-form>
								</v-card-text>

								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="green darken-1" text @click="privateRoom.dialog = false">Cancel</v-btn>
									<v-btn
										:disabled="!privateRoom.validForm"
										color="green darken-1"
										text
										@click="
											privateRoom.dialog = false;
											createPrivateChatRoom();
										"
										>Save</v-btn
									>
								</v-card-actions>
							</v-card>
						</v-dialog>

						<v-dialog v-model="privateInvite.dialog" max-width="70%">
							<v-card>
								<v-card-title class="headline">
									Invite Members to
									{{ privateInvite.room.name }}
								</v-card-title>

								<v-card-text>
									<v-form ref="privateInviteForm" v-model="privateInvite.validForm">
										Select user that you want to invite.
										<v-row class="pa-2">
											<v-autocomplete
												v-model="privateInvite.toBeInvited"
												:items="privateInvite.nonMembersList"
												:rules="privateInvite.memberInviteRules"
												filled
												chips
												color="#4e7c83"
												label="Selected user(s)"
												item-text="name"
												item-value="uid"
												multiple
											>
												<template v-slot:selection="data">
													<v-chip
														v-bind="data.attrs"
														:input-value="data.selected"
														close
														@click="data.select"
														@click:close="removeUser(data.item)"
														>{{ data.item.name }}</v-chip
													>
												</template>

												<template v-slot:item="data">
													<template v-if="typeof data.item !== 'object'">
														<v-list-item-content v-text="data.item"></v-list-item-content>
													</template>
													<template v-else>
														<v-list-item-content>
															<v-list-item-title v-html="data.item.name"></v-list-item-title>
														</v-list-item-content>
													</template>
												</template>
											</v-autocomplete>
										</v-row>
									</v-form>
								</v-card-text>

								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="green darken-1" text @click="privateInvite.dialog = false">Cancel</v-btn>
									<v-btn
										color="green darken-1"
										:disabled="!privateInvite.validForm"
										text
										@click="
											privateInvite.dialog = false;
											addMembersToGroup(privateInvite.room.guid, privateInvite.toBeInvited);
										"
										>Save</v-btn
									>
								</v-card-actions>
							</v-card>
						</v-dialog>

						<v-dialog v-model="privateKick.dialog" max-width="70%">
							<v-card>
								<v-card-title class="headline">
									Kick members from
									{{ privateKick.room.name }}
								</v-card-title>

								<v-card-text>
									<v-form ref="privateKickForm" v-model="privateKick.validForm">
										Select user that you want to kick.
										<v-row class="pa-2">
											<v-autocomplete
												v-model="privateKick.toBeKicked"
												:items="privateKick.membersList"
												:rules="privateKick.memberKickRules"
												filled
												chips
												color="#4e7c83"
												label="Selected user(s)"
												item-text="name"
												item-value="uid"
												multiple
											>
												<template v-slot:selection="data">
													<v-chip
														v-bind="data.attrs"
														:input-value="data.selected"
														close
														@click="data.select"
														@click:close="removeUser(data.item)"
														>{{ data.item.name }}</v-chip
													>
												</template>

												<template v-slot:item="data">
													<template v-if="typeof data.item !== 'object'">
														<v-list-item-content v-text="data.item"></v-list-item-content>
													</template>
													<template v-else>
														<v-list-item-content>
															<v-list-item-title v-html="data.item.name"></v-list-item-title>
														</v-list-item-content>
													</template>
												</template>
											</v-autocomplete>
										</v-row>
									</v-form>
								</v-card-text>

								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="green darken-1" text @click="privateKick.dialog = false">Cancel</v-btn>
									<v-btn
										color="green darken-1"
										:disabled="!privateKick.validForm"
										text
										@click="
											privateKick.dialog = false;
											kickFromChatRoom();
										"
										>Save</v-btn
									>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</v-card>
				</v-col>
				<!-- ------------------------Chatbox start------------------------------------------- -->
				<v-col :cols="!isMobile ? 6 : 12" class="d-flex flex-column pa-0" v-if="!isMobile || (isMobile && showChat)">
					<v-card width="100%" height="100%" color="grey lighten-2" tile>
						<v-tabs v-model="mobileTab" background-color="#4e7c83" dark show-arrows fixed-tabs v-if="isMobile">
							<v-tab v-for="(category, idxCategory) in tabMobileCategories" :key="idxCategory" @click="toTabMenu(category.content)">
								<v-badge :value="category.isBadgeOn">{{ category.tab }}</v-badge>
							</v-tab>
						</v-tabs>

						<div v-if="Object.keys(chatRoom).length">
							<div
								v-if="Object.keys(chatRoom).length > 2 && (!meetingProperties.sessionId || meetingProperties.sessionId == '') && chatRoom.conversationId.includes('-m-')"
								class="d-flex justify-end align-center"
								style="background-color: white"
							>
								<v-btn class="mx-2" icon large @click="callUser(groupId, 'video', 'group')">
									<v-icon>mdi-video</v-icon>
								</v-btn>
								<v-btn class="mx-2" icon large @click="callUser(groupId, 'audio', 'group')">
									<v-icon>mdi-microphone</v-icon>
								</v-btn>
							</div>
							<div
								v-if="Object.keys(chatRoom).length > 2 && meetingProperties.sessionId && meetingProperties.sessionId != ''  && chatRoom.conversationId.includes('-m-')"
								class="d-flex justify-end align-center"
								style="background-color: white"
							>
								<v-btn color="white" elevation="0" @click="acceptCall()">
									JOIN CALL
									<v-icon>mdi-phone-plus</v-icon>
								</v-btn>
							</div>
							<div style="height: 100%; padding: 0 !important">
								<v-card-text>
									<div class="scrollable" id="msg-page">
										<div v-if="chatBox.loadingMessages" style="height: 100%; width: 100%">
											<v-card
												flat
												height="100%"
												width="100%"
												style="background-color: rgba(0, 0, 0, 0)"
												class="d-flex flex-column align-center justify-center"
											>
												<v-row class="d-flex flex-column align-center justify-center">
													<v-col cols="12" class="text-center">
														<v-progress-circular :size="200" color="#4e7c83" indeterminate></v-progress-circular>
														<p class="pt-6">Loading Messages</p>
													</v-col>
												</v-row>
											</v-card>
										</div>

										<div v-else>
											<div class="d-flex flex-column align-center">
												<a v-if="!chatBox.noMoreMessages" @click="loadPreviousMessages()">Load previous messages</a>
											</div>
											<div
												:id="'msg-' + message.id"
												v-for="(message, idxMessage) in chatBox.listMessages"
												v-bind:key="idxMessage"
											>
												<!-- incoming -->
												<div v-if="message.sender.uid != currentUser.uid && message.category == 'message'">
													<div>
														<v-row class="mx-5">
															<v-col cols="1">
																<v-avatar color="white">
																	<v-img :src="profilePicture(message.sender.uid)" @error="setAltImg"></v-img>
																</v-avatar>
															</v-col>
															<v-col cols="11">
																<v-card width="70%" class="pa-4">
																	<span style="font-weight: bold">{{ message.sender.name }}</span>
																	<br />
																	{{ message.data.text }}
																</v-card>
																<span style="color: #646464">{{ formatDate(message.sentAt) }}</span>
															</v-col>
														</v-row>
													</div>
												</div>

												<!-- outgoing -->
												<div v-else-if="message.category == 'message'">
													<v-row>
														<v-col cols="11" class="d-flex flex-column align-end">
															<v-card
																:color="color.bubbleBackgroundColor"
																:style="{ color: color.bubbleFontColor }"
																width="70%"
																class="pa-4"
																>{{ message.data.text }}</v-card
															>
															<span style="color: #646464">{{ formatDate(message.sentAt) }}</span>
														</v-col>
														<v-col cols="1">
															<v-avatar color="white">
																<v-img :src="profilePicture(message.sender.uid)" @error="setAltImg"></v-img>
															</v-avatar>
														</v-col>
													</v-row>
												</div>

												<div v-else-if="message.category == 'call'">
													<v-row>
														<v-col cols="12" class="d-flex flex-column align-center">
															<v-card color="rgb(255, 0, 0, 0)" elevation="0">
																<v-card-text>
																	<span style="color: #646464">
																		Call
																		{{ message.callInitiator.uid != currentUser.uid ? "from" : "to" }}
																		{{
																			message.callInitiator.uid != currentUser.uid
																				? message.callInitiator.name
																				: message.callReceiver.name
																		}}
																		is
																		{{ message.action }}
																	</span>
																</v-card-text>
															</v-card>
														</v-col>
													</v-row>
												</div>

												<div v-else-if="message.category == 'action'">
													<v-row>
														<v-col cols="12" class="d-flex flex-column align-center">
															<v-card color="rgb(255, 0, 0, 0)" elevation="0">
																<v-card-text>
																	<span style="color: #646464">
																		{{ message.message }}
																	</span>
																</v-card-text>
															</v-card>
														</v-col>
													</v-row>
												</div>
											</div>
										</div>
									</div>
								</v-card-text>

								<div style="background-color: white !important">
									<v-form ref="messageForm" v-model="chatBox.validMessage">
										<div>
											<v-textarea
												class="d-flex justify-center"
												v-model="chatBox.chatMessage"
												:rules="chatBox.chatMessageRules"
												placeholder="Type your message here"
												:append-icon="chatBox.validMessage && !chatBox.sendingMessage ? 'mdi-send' : undefined"
												@click:append="sendMessage(chatRoom)"
												solo
												dense
												hide-details
												no-resize
												rows="3"
											></v-textarea>
										</div>
									</v-form>
								</div>
							</div>
						</div>
						<div v-else></div>
					</v-card>
				</v-col>
				<!-- ------------------------Chatbox end------------------------------------------- -->
				<v-col :cols="!isMobile ? 3 : 12" class="d-flex flex-column pa-0" v-if="!isMobile || (isMobile && showUserOnline)">
					<v-card class="scrollable" width="100%" height="100%" elevation dark tile>
						<v-tabs v-model="mobileTab" background-color="#4e7c83" dark show-arrows fixed-tabs v-if="isMobile">
							<v-tab v-for="(category, idxCategory) in tabMobileCategories" :key="idxCategory" @click="toTabMenu(category.content)">
								<v-badge :value="category.isBadgeOn">{{ category.tab }}</v-badge>
							</v-tab>
						</v-tabs>
						<h2 v-if="!isMobile">
							<v-container>
								<v-row no-gutters class="d-flex justify-end align-end pb-0">
									<v-col :cols="3"> </v-col>
									<v-col :cols="5" class="d-flex justify-end">
										<v-card-text class="font-weight-bold" style="text-align: right"> Chat Notification Sound </v-card-text>
									</v-col>
									<v-col :cols="4" class="d-flex justify-end">
										<v-switch
											@change="soundSwitch()"
											v-model="chatBox.chatNotificationSound"
											inset
											:label="chatBox.chatNotificationSound ? 'Active' : 'Inactive'"
											dense
										></v-switch>
									</v-col>
								</v-row>
							</v-container>
							<center>
								Users Online
								<v-menu top offset-y>
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon dark v-bind="attrs" v-on="on">
											<v-icon>mdi-information-outline</v-icon>
										</v-btn>
									</template>

									<v-list dense>
										<v-list-item>
											<v-list-item-title>You don't see yourself as online in the list below.</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</center>
						</h2>
						<hr />
						<v-container v-if="isMobile">
							<v-row no-gutters class="d-flex justify-end align-end pb-0">
								<v-col :cols="3"> </v-col>
								<v-col :cols="5" class="d-flex justify-end">
									<v-card-text class="font-weight-bold" style="text-align: right"> Chat Notification Sound </v-card-text>
								</v-col>
								<v-col :cols="4" class="d-flex justify-end">
									<v-switch
										@change="soundSwitch()"
										v-model="chatBox.chatNotificationSound"
										inset
										:label="chatBox.chatNotificationSound ? 'Active' : 'Inactive'"
										dense
									></v-switch>
								</v-col>
							</v-row>
						</v-container>

						<v-list-item-group v-model="onlineUserNumber">
							<v-list-item v-for="(onlineUserNumber, i) in onlineUsers" :key="i">
								<v-list-item-icon>
									<v-avatar color="white">
										<v-img :src="profilePicture(onlineUserNumber.uid)" @error="setAltImg"></v-img>
									</v-avatar>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title v-text="onlineUserNumber.name"></v-list-item-title>
								</v-list-item-content>
								<v-btn
									class="mx-2"
									icon
									small
									dark
									@click="chatRoom.uid != onlineUserNumber.uid || isMobile ? onlineUserClicked(onlineUserNumber) : ''"
								>
									<v-icon>mdi-message</v-icon>
								</v-btn>

								<v-menu offset-y class="mx-2">
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon small dark v-bind="attrs" v-on="on">
											<v-icon>mdi-phone</v-icon>
										</v-btn>
									</template>
									<v-list flat elevation="0">
										<v-list-item @click="callUser(onlineUserNumber.uid, 'video', 'user')">
											<v-list-item-icon class="mr-4">
												<v-icon>mdi-video</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Video Call</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="callUser(onlineUserNumber.uid, 'audio', 'user')">
											<v-list-item-icon class="mr-4">
												<v-icon>mdi-microphone</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Audio Call</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-list-item>
						</v-list-item-group>
					</v-card>
				</v-col>

				<!-- incoming call dialog -->
				<v-dialog v-model="call.incomingCall" persistent no-click-animation max-width="300">
					<v-card rounded="xl" dark elevation="0">
						<v-card-text class="d-flex flex-column align-center pa-4">
							Incoming call
							<br />
							<span class="font-weight-bold body-1" style="text-align: center">
								{{ call.caller && call.caller.name ? call.caller.name : "" }}
							</span>
						</v-card-text>
						<v-card-actions class="pt-2 pb-4 px-8">
							<v-btn class="mx-2" fab dark color="green" @click="acceptCall()">
								<v-icon dark>mdi-phone</v-icon>
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn class="mx-2" fab dark color="red" @click="rejectCall('rejected')">
								<v-icon dark>mdi-phone-hangup</v-icon>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<!-- ongoing call dialog -->
				<v-dialog v-model="call.ongoingCall" persistent no-click-animation max-width="500">
					<v-card dark elevation="0">
						<div id="callScreen"></div>
					</v-card>
				</v-dialog>

				<!-- call on progress dialog -->
				<v-dialog v-model="call.callingProgress" persistent no-click-animation max-width="300">
					<v-card rounded="xl" dark elevation="0">
						<v-card-text class="d-flex flex-column align-center pa-4">
							Calling...
							<br />
							<span class="font-weight-bold body-1" style="text-align: center">
								{{ call.receiver && call.receiver.name ? call.receiver.name : "" }}
							</span>
						</v-card-text>
						<v-card-actions class="pt-2 pb-4 px-8 d-flex flex-column align-center">
							<v-btn class="mx-2" fab dark color="red" @click="rejectCall('cancelled')">
								<v-icon dark>mdi-phone-hangup</v-icon>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-row>
			<v-row v-else >
				<v-col cols="12" class="ml-4" style="margin-bottom: 10px">
					<iframe
						:src="$vchaturl + '/frontend/?e=' + $store.state.principal.chatEventToken +
							'&r=' + meeting.dataMap.ChatRoomToken +
							'&u=' + $store.state.principal.chatUserToken +
							'&o=&i=&sr=0&sm=1&seu=0&sru=1'"
						style="height:725px; width: 98%"
						allow="camera; microphone;"
					></iframe>
				</v-col>
			</v-row>
			<v-row v-if="$store.state.isPoweredBy" style="background-color: black">
				<v-col cols="12" sm="12">
					<div id="v-footer" style="height: 50px; background-color: black" v-if="$store.state.footerText === ''">
						<p class="text-center" style="color: #cccccc;padding-top: 15px">Powered by <a href="https://v-unite.com/" target="_blank" style="color:#cccccc">V-Unite</a></p>
					</div>
                    <div id="v-footer" style="height: 50px; background-color: black" v-else>
						<p class="text-center" style="color: #cccccc;padding-top: 15px">{{ $store.state.footerText }}</p>
					</div>
				</v-col>
			</v-row>
		</div>
	</v-main>
</template>

<style scoped>
.scrollable {
	overflow-y: auto;
	overflow-x: hidden;
	height: 73vh;
}

.chat.v-list-item--active {
	background-color: rgb(235, 110, 31);
	color: #fff !important;
	font-weight: bold;
}

.chatList1 {
	background-color: rgba(0, 0, 0, 0);
}

.chatList2 {
	background-color: rgba(255, 255, 255, 0.1);
}

.theme--light.v-icon {
	color: rgb(235, 110, 31) !important;
}

#callScreen {
	width: 500px;
	height: 500px;
}

.clamp span {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
</style>

<script>
import { CometChat } from "@cometchat-pro/chat";
import axios from "axios";
import configuration from "../../configuration";

export default {
	props: ["tenantSlug", "experienceSlug", "meetingId"],
	data() {
		return {
			baseLocation: axios.defaults.baseURL,
			chatTab: 1,
			chatCategories: [
				{ tab: "Direct Messages", content: "1", isBadgeOn: false },
				{ tab: "Chat Rooms", content: "2", isBadgeOn: false }
			],
			tabMobileCategories: [
				{ tab: "Conversation", content: "1", isBadgeOn: false },
				{ tab: "Chat Area", content: "2", isBadgeOn: false },
				{ tab: "Users Online", content: "3", isBadgeOn: false }
			],
			notification: { show: false, title: "", content: "" },
			currentUser: {},
			chatRoomNumber: null,
			onlineUserNumber: null,
			directMessageNumber: null,
			chatRoom: {},
			chatRooms: [],
			directMessages: [],
			notJoinedChatRooms: [],
			onlineUsers: [],
			allUsers: [],
			imgError: false,
			groupId: this.$store.state.principal.experienceId + "-m-" + this.meetingId,
			busId: this.$store.state.principal.experienceId + "-bus",
			chatBox: {
				messagesRequest: null,
				noMoreMessages: false,
				validMessage: false,
				sendingMessage: false,
				chatMessage: "",
				chatMessageRules: [(v) => (!!v && /.*[^ ].*/.test(v)) || "Please enter your message"],
				listMessages: [],
				loadingMessages: false,
				chatNotificationSound: false
			},
			privateRoom: {
				toBeJoinedUsers: [],
				validForm: false,
				dialog: false,
				name: "",
				nameRules: [
					(v) => (!!v && /.*[^ ].*/.test(v)) || "Name cannot be blank",
					(v) => (v && !/[^a-zA-Z0-9 ]/.test(v)) || "Only letters, numbers and spaces are allowed"
				],
				memberRules: [(v) => (!!v && /.*[^ ].*/.test(v)) || "Please select at least one member"]
			},
			privateInvite: {
				validForm: false,
				nonMembersList: [],
				toBeInvited: [],
				dialog: false,
				name: "",
				room: {},
				memberInviteRules: [(v) => (!!v && /.*[^ ].*/.test(v)) || "Please select at least one member"]
			},
			privateKick: {
				validForm: false,
				membersList: [],
				toBeKicked: [],
				dialog: false,
				name: "",
				room: {},
				memberKickRules: [(v) => (!!v && /.*[^ ].*/.test(v)) || "Please select at least one member"]
			},
			call: {
				sessionId: "",
				receiverId: null,
				caller: null,
				receiver: null,
				callingProgress: false,
				incomingCall: false,
				ongoingCall: false
			},
			isMobile: false,
			showConversation: true,
			showChat: false,
			showUserOnline: false,
			mobileTab: 1,
			color: {
				backgroundColor: "#4e7c83FF",
				fontColor: "#FFFFFFFF",
				bubbleFontColor: "#000000DE",
				bubbleBackgroundColor: "#5F949C"
			},
			meeting: null,
			authentication: false,
			meetingProperties: {
				sessionId: null,
				receiverType: null
			},
			isInCall: false,
			uid: this.$store.state.principal.chatId
		};
	},
	created: async function () {
		await this.authenticationCheck();

		if (this.authentication) {
			if (this.meeting.transitMap.isUseCometChat) {
				await this.cometEnter();

				let activityLog = { type: "Visit_chat_lounge" };
				this.$root.saveActivityLog(activityLog);

				let groupId = this.groupId;
				let busId = this.busId;

				let messageListenerID = "messageListener-" + groupId;

				CometChat.addMessageListener(
					messageListenerID,
					new CometChat.MessageListener({
						onTextMessageReceived: async (textMessage) => {
							// for event bus handling only, new way to list online users
							if (textMessage.receiverId == busId) {
								let data = JSON.parse(textMessage.data.text);
								if (data.type == "Enter group" && data.groupId == groupId) {
									let uid = textMessage.sender.uid;
									let found = false;
									for (let user of this.onlineUsers) {
										if (user.uid == uid) {
											found = true;
											break;
										}
									}
									if (!found) {
										this.onlineUsers.push({ uid: textMessage.sender.uid, name: textMessage.sender.name });
									}
								} else if ((data.type == "Exit group" && data.groupId == groupId) || data.type == "Logout") {
									let uid = textMessage.sender.uid;
									for (let i in this.onlineUsers) {
										let user = this.onlineUsers[i];
										if (user.uid == uid) {
											this.onlineUsers.splice(i, 1);
											break;
										}
									}
								}
							} else {
								// anything besides event bus handling
								await this.getMessageHistory(this.chatRoom);

								if (textMessage.receiverType == "user") {
									// to refresh receiver's direct messages list
									if (this.chatRoom.uid == textMessage.sender.uid) {
										// if chat box with related user is open, then mark as read (and refresh direct messages list)
										await this.markAsRead(textMessage.id, textMessage.sender.uid, "user");
									} else {
										// otherwise, just refresh the direct messages list only
										await this.getDirectMessages();
									}
								} else if (textMessage.receiverType == "group") {
									// to refresh unread message count for chat rooms
									if (this.chatRoom.guid == textMessage.receiverId) {
										// if chat box with related user is open, then only mark as read, not refreshing the list
										// (unlike direct messages, chat rooms dont have the last message text, so no need to refresh the list)
										await CometChat.markAsRead(textMessage.id, textMessage.receiverId, textMessage.receiverType);
									} else {
										// otherwise, refresh the chat rooms list
										await this.getAllChatRooms();
									}
								}

								if (this.chatBox.chatNotificationSound) {
									this.notificationSound();
								}

								this.$nextTick(() => {
									this.scrollToBottom();
								});
							}
						}
					})
				);

				let groupListenerID = "groupListener-" + groupId;

				CometChat.addGroupListener(
					groupListenerID,
					new CometChat.GroupListener({
						onMemberAddedToGroup: async (message, userAdded, userAddedBy, userAddedIn) => {
							console.log("User added to group", {
								message,
								userAdded,
								userAddedBy,
								userAddedIn
							});
							await this.getAllChatRooms();
						},
						onGroupMemberJoined: async (message, joinedUser, joinedGroup) => {
							console.log("User joined", {
								message,
								joinedUser,
								joinedGroup
							});
						},
						onGroupMemberLeft: async (message, leavingUser, group) => {
							console.log("User left", {
								message,
								leavingUser,
								group
							});

							await this.getAllChatRooms();
						},
						onGroupMemberKicked: async (message, kickedUser, kickedBy, kickedFrom) => {
							console.log("User kicked", {
								message,
								kickedUser,
								kickedBy,
								kickedFrom
							});

							if (kickedUser.uid == this.currentUser.uid) {
								this.chatRoom = {};
							}
							await this.getAllChatRooms();
						}
					})
				);

				let callListenerID = "callListener-" + groupId;
				let globalContext = this;

				await globalContext.getPropeties();
				await globalContext.checkParticipants(globalContext);

				CometChat.addCallListener(
					callListenerID,
					new CometChat.CallListener({
						onIncomingCallReceived(call) {
							globalContext.getPropeties();
							if (
								call.callInitiator.uid != globalContext.currentUser.uid &&
								!globalContext.call.ongoingCall &&
								globalContext.call.sessionId == "" && //
								(globalContext.groupId == call.receiverId || call.receiverType == "user")
							) {
								console.log("Incoming call:", call);
								globalContext.call.caller = call.callInitiator;
								globalContext.call.receiver = call.callReceiver;
								globalContext.call.incomingCall = true;
								globalContext.call.sessionId = call.sessionId;
							}
						},
						onOutgoingCallAccepted(call) {
							console.log("Outgoing call accepted:", call);

							if (!globalContext.isInCall) {
								globalContext.isInCall = true;
								globalContext.meetingProperties.status = call.status;
								globalContext.setProperties();

								globalContext.setOnCallAccepted().then(() => {
									let css = ".main-tile-container-portrait {flex-direction: row;}.tile-main-video-container-portrait {flex: 1 1;height: 89%;margin: 5px 2% 5%;border-radius: 10px;}.tile-list-container-portrait {width: 15%;height: 89%;padding-left: 0;padding-right: 1%;padding-top: .5%;display: flex;align-items: center;flex-direction: column;overflow-y: auto;}.tile-container-mob {width: 90%;position: relative;aspect-ratio: 1;background-color: #000000;margin-bottom: 10px; border-radius: 0.7rem;}.thumb-mobile { width: none;height: none;margin-bottom: none;}";
									let sessionId = call.sessionId;
									let callType = call.type;
									let callSettings = new CometChat.CallSettingsBuilder()
										.setSessionID(sessionId)
										.enableDefaultLayout(true)
										.setIsAudioOnlyCall(callType == "audio" ? true : false)
										.showScreenShareButton(false)
										.setCustomCSS(css)
										.build();

									CometChat.startCall(
										callSettings,
										document.getElementById("callScreen"),
										new CometChat.OngoingCallListener({
											onUserListUpdated: (userList) => {
												console.log("user list:", userList);
											},
											onUserJoined: (user) => {
												/* Notification received here if another user joins the call. */
												console.log("User joined call:", user);
											},
											onUserLeft: (user) => {
												/* Notification received here if another user left the call. */
												console.log("User left call:", user);
											},
											onCallEnded: (call) => {
												/* Notification received here if current ongoing call is ended. */
												console.log("Call ended:", call);
												globalContext.call.ongoingCall = false;
												globalContext.call.incomingCall = false;
												globalContext.call.callingProgress = false;
												globalContext.call.receiverId = null;
												globalContext.call.sessionId = "";

												if (call.status == "ended") {
													if (globalContext.meetingProperties.receiverType == "group") {
														globalContext.meetingProperties.sessionId = null;
														globalContext.meetingProperties.receiverType = null;
														globalContext.meetingProperties.joinedAt = null;
														globalContext.meetingProperties.status = null;
														globalContext.setProperties();
													}
													globalContext.isInCall = false;
												}
												globalContext.checkParticipants(globalContext);
											},
											onError: (error) => {
												console.log("Call Error :", error);
												globalContext.call.ongoingCall = false;
												globalContext.call.incomingCall = false;
												globalContext.call.callingProgress = false;
												globalContext.call.receiverId = null;
												globalContext.call.sessionId = "";
											}
										})
									);
								});
							}
						},
						onOutgoingCallRejected(call) {
							console.log("Outgoing call rejected:", call);
							globalContext.call.incomingCall = false;
							globalContext.call.ongoingCall = false;
							globalContext.call.callingProgress = false;
							globalContext.call.receiverId = null;
							globalContext.call.sessionId = "";

							if (call.status == "unanswered") {
								if (globalContext.meetingProperties.receiverType == "group") {
									globalContext.meetingProperties.sessionId = null;
									globalContext.meetingProperties.receiverType = null;
									globalContext.meetingProperties.joinedAt = null;
									globalContext.meetingProperties.status = null;
									globalContext.setProperties();
								}
								globalContext.isInCall = false;
							}
						},
						onIncomingCallCancelled(call) {
							if (globalContext.call.caller.name == call.callInitiator.name) {
								console.log("Incoming call cancelled:", call);
								globalContext.call.incomingCall = false;
								globalContext.call.ongoingCall = false;
								globalContext.call.callingProgress = false;
								globalContext.call.receiverId = null;
								globalContext.call.sessionId = "";

								if (call.status == "cancelled" || call.status == "unanswered") {
									if (globalContext.meetingProperties.receiverType == "group") {
										globalContext.meetingProperties.sessionId = null;
										globalContext.meetingProperties.receiverType = null;
										globalContext.meetingProperties.joinedAt = null;
										globalContext.meetingProperties.status = null;
										globalContext.setProperties();
									}
									globalContext.isInCall = false;
								}
							}
						}
					})
				);
				await this.chatRoomClicked(this.chatRooms[0]);
			} else {
				let activityLog = { type: "Visit_chat_lounge" };
				this.$root.saveActivityLog(activityLog);
			}
		}
	},
	mounted: function () {
		this.getColor();
		this.onResize();
		this.getExperienceUser();
		window.addEventListener("resize", this.onResize, { passive: true });
	},
	beforeDestroy: function () {
		this.cometExit();
	},
	methods: {
		getExperienceUser() {
			axios
				.get("/system/user")
				.then((response) => {
					this.chatBox.chatNotificationSound = response.data.chatNotificationSound ? response.data.chatNotificationSound : false;
				})
				.catch(() => {});
		},
		async cometEnter() {
			try {
				await this.getPropeties();
				this.isInCall = this.meetingProperties.sessionId != null;

				let groupId = this.groupId;
				let busId = this.busId;

				// Get current logged-in user
				let user = await CometChat.getLoggedinUser();
				this.currentUser = user;

				let role = this.$store.state.principal.experienceId + "-m-" + this.meetingId;

				// Check Role
				try {
					await axios.get("/system/chat/user/search/role?role=" + role);
				} catch {
					console.log("need to create role");
				}

				//Edit Role
				let uid = this.currentUser.uid;
				let data = { role: role };

				try {
					await axios.post("/system/chat/user/edit/role", { uid, data });
				} catch (error) {
					console.log("Role edit failed: ", error);
				}

				// Get and fill direct messages and chat rooms tabs - left pane
				await this.getDirectMessages();
				await this.getAllChatRooms();

				// notify in bus that just entered group
				await CometChat.sendMessage(
					new CometChat.TextMessage(busId, JSON.stringify({ type: "Enter group", groupId: groupId }), CometChat.RECEIVER_TYPE.GROUP)
				);

				// Get list of online users - right pane
				await this.getOnlineUsers();
			} catch (error) {
				this.cometChatErrorNotif(error);
			}
		},
		async cometExit() {
			let groupId = this.groupId;
			let busId = this.busId;

			CometChat.removeMessageListener("messageListener-" + groupId);
			CometChat.removeGroupListener("groupListener-" + groupId);
			CometChat.removeCallListener("callListener-" + groupId);

			document.title = "V-Unite";

			if (this.$store.state.principal.token) {
				this.currentUser.role = "default";
				await CometChat.updateUser(this.currentUser, configuration.apiKeyCometChat);

				await CometChat.sendMessage(
					new CometChat.TextMessage(busId, JSON.stringify({ type: "Exit group", groupId: groupId }), CometChat.RECEIVER_TYPE.GROUP)
				);
			}
		},
		async checkRole(role) {
			await axios
				.get("/system/chat/user/search/role?role=" + role)
				.then(() => {})
				.catch(() => {
					console.log("need to create role");
				});
		},
		async editUserRole(uid, role) {
			let data = { role: role };

			await axios
				.post("/system/chat/user/edit/role", {
					uid,
					data
				})
				.then(() => {})
				.catch((error) => {
					console.log("Role edit failed: ", error);
				});
		},
		async directMessageClicked(directMessage) {
			if (this.isMobile) {
				this.showConversation = false;
				this.showChat = true;
				this.showUserOnline = false;
			}
			this.chatRoom = directMessage.conversationWith;
			this.chatBox.loadingMessages = true;
			await this.getMessageHistory(this.chatRoom);
			if (directMessage.unreadMessageCount != 0) {
				await this.markAsRead(directMessage.lastMessage.id, this.chatRoom.uid, "user");
			}
		},
		async chatRoomClicked(chatRoom) {
			this.getPropeties();
			this.chatRoom = chatRoom;
			if (this.isMobile) {
				this.showConversation = false;
				this.showChat = true;
				this.showUserOnline = false;
			}
			this.chatBox.loadingMessages = true;
			await this.getOneGroupMember(this.chatRoom);
			await this.getMessageHistory(this.chatRoom);
			if (this.chatRoom.unreadMessageCount != 0) {
				await this.markAsRead(this.chatRoom.lastMessage.id, this.chatRoom.guid, "group");
			}
		},
		async onlineUserClicked(onlineUser) {
			this.chatRoom = onlineUser;
			if (this.isMobile) {
				this.showConversation = false;
				this.showChat = true;
				this.showUserOnline = false;
			}
			this.chatBox.loadingMessages = true;
			await this.getMessageHistory(this.chatRoom);
		},
		async joinToChatRoom(groupType, guid) {
			let password = "";

			try {
				await CometChat.joinGroup(guid, groupType == "public" ? CometChat.GROUP_TYPE.PUBLIC : CometChat.GROUP_TYPE.PRIVATE, password);
				await this.getAllChatRooms();
			} catch (error) {
				this.cometChatErrorNotif(error);
			}
		},
		async leaveChatRoom(room) {
			if (confirm("Are you sure you want to leave this chat room?")) {
				try {
					let groupMembers = await this.getGroupMemberList(room);

					await CometChat.leaveGroup(room.guid);
					this.chatRoom = {};
					await this.getAllChatRooms();

					//remove group if empty members
					if (groupMembers.length == 1) {
						let guid = room.guid;

						try {
							await axios.post("/system/chat/group/delete", { guid });
						} catch (error) {
							console.log("Group delete failed: ", error);
						}
					}
				} catch (error) {
					this.cometChatErrorNotif(error);
				}
			}
		},
		async beforeInviteToChatRoom() {
			this.privateInvite.nonMembersList = [];
			this.privateInvite.toBeInvited = [];

			await this.getAllUsers();
			let groupMembers = await this.getGroupMemberList(this.privateInvite.room);
			this.privateInvite.nonMembersList = this.allUsers.filter((user) => {
				return !groupMembers.some((member) => {
					return member.name === user.name && member.uid === user.uid;
				});
			});
		},
		async beforeKickFromChatRoom() {
			this.privateKick.membersList = [];
			this.privateKick.toBeKicked = [];
			this.privateKick.membersList = (await this.getGroupMemberList(this.privateKick.room)).filter((member) => {
				return member.uid != this.currentUser.uid;
			});
		},
		async kickFromChatRoom() {
			if (confirm("Are you sure you want to kick the member(s)?")) {
				let guid = this.privateKick.room.guid;
				let uid = "";

				for (let i = 0; i < this.privateKick.toBeKicked.length; i++) {
					uid = this.privateKick.toBeKicked[i];

					await axios
						.post("/system/chat/group/member/kick", {
							guid,
							uid
						})
						.then(async () => {})
						.catch(async (error) => {
							console.log("Member kicked failed: ", error);
						});
				}
			}
		},
		async addMembersToGroup(guid, membersList) {
			let addedMembers = [];
			for (let i = 0; i < membersList.length; i++) {
				addedMembers.push(new CometChat.GroupMember(membersList[i], CometChat.GROUP_MEMBER_SCOPE.ADMIN));
			}

			try {
				await CometChat.addMembersToGroup(guid, addedMembers, []);
			} catch (error) {
				this.cometChatErrorNotif(error);
			}
		},
		async createPrivateChatRoom() {
			let experienceId = this.$store.state.principal.experienceId;
			let guid = this.toHexString(this.privateRoom.name);

			let name = this.privateRoom.name;
			let type = "private";
			let metadata = {
				type: "General Private",
				experienceId: experienceId
			};

			if (this.privateRoom.toBeJoinedUsers.length > 0) {
				try {
					await axios.post("/system/chat/group/add", {
						guid,
						name,
						type,
						metadata
					});
					await this.addMembersToGroup(guid, this.privateRoom.toBeJoinedUsers);
				} catch (error) {
					console.log("Private group add failed: ", error);
				}
			} else {
				console.log("At least invite 1 member to chat room");
			}
		},
		async getDirectMessages() {
			this.directMessages = [];
			let limit = 50;
			let conversationsRequest = new CometChat.ConversationsRequestBuilder().setLimit(limit).setConversationType("user").build();

			do {
				var fetchDirectMessages = await conversationsRequest.fetchNext().then(
					(conversationList) => {
						return conversationList;
					},
					(error) => {
						this.cometChatErrorNotif(error);
						return null;
					}
				);

				this.directMessages.push(...fetchDirectMessages);
			} while (fetchDirectMessages.length === limit);

			this.chatCategories[0].isBadgeOn = this.directMessages.find((x) => x.unreadMessageCount > 0) ? true : false;
			document.title = this.chatCategories[0].isBadgeOn || this.chatCategories[1].isBadgeOn ? "You have new message(s)" : "V-Unite";
		},
		async getConversationForChatRooms() {
			let limit = 50;
			let conversationsRequest = new CometChat.ConversationsRequestBuilder().setLimit(limit).setConversationType("group").build();

			let allChatRoomConversation = [];
			do {
				var fetchChatRoomConversation = await conversationsRequest.fetchNext().then(
					(conversationList) => {
						return conversationList;
					},
					(error) => {
						this.cometChatErrorNotif(error);
						return [];
					}
				);

				allChatRoomConversation.push(...fetchChatRoomConversation);
			} while (fetchChatRoomConversation.length === limit);

			// All group conversation (for chat rooms) type filtering (filtered by General Public, General Private and Presentation)
			return allChatRoomConversation.filter((conversation) => {
				return (
					conversation.conversationWith.metadata &&
					(conversation.conversationWith.metadata.type == "General Public" ||
						conversation.conversationWith.metadata.type == "General Private" ||
						conversation.conversationWith.metadata.type == "Presentation") &&
					conversation.conversationWith.metadata.experienceId == this.$store.state.principal.experienceId
				);
			});
		},
		async getAllChatRooms() {
			this.chatRooms = [];
			let limit = 100;
			let groupsRequest = new CometChat.GroupsRequestBuilder()
				.setLimit(limit)
				.setSearchKeyword(this.$store.state.principal.experienceId + "-m-" + this.meetingId)
				.build();

			let groupConversation = await this.getConversationForChatRooms();

			let allChatRooms = [];
			do {
				var fetchAllChatRooms = await groupsRequest.fetchNext().then(
					async (groupList) => {
						return groupList;
					},
					async (error) => {
						this.cometChatErrorNotif(error);
						return [];
					}
				);

				allChatRooms.push(...fetchAllChatRooms);
			} while (fetchAllChatRooms.length === limit);

			// All chat rooms type filtering (filtered by General Public, General Private and Presentation)
			// Also mapping with group conversation to get lastMessage & unreadMessageCount for notification bubble purposes
			// If sortingOrder exists, sorted by sortingOrder (in metadata)
			if (allChatRooms.length > 0) {
				this.chatRooms = allChatRooms
					.filter((group) => {
						return (
							group.metadata &&
							(group.metadata.type == "General Public" ||
								group.metadata.type == "General Private" ||
								group.metadata.type == "Presentation") &&
							group.metadata.experienceId == this.$store.state.principal.experienceId
						);
					})
					.map((x) => {
						let conversation = groupConversation.find((y) => y.conversationWith.guid == x.guid);
						groupConversation;
						return {
							...x,
							isJoined: conversation !== undefined,
							lastMessage: conversation ? conversation.lastMessage : null,
							unreadMessageCount: conversation ? conversation.unreadMessageCount : null
						};
					});
			}

			this.chatRooms = this.chatRooms.sort(function (a, b) {
				if (a.metadata && a.metadata.sortingOrder && b.metadata && b.metadata.sortingOrder) {
					return a.metadata.sortingOrder - b.metadata.sortingOrder;
				} else if (a.metadata && a.metadata.sortingOrder) {
					return 1;
				} else if (b.metadata && b.metadata.sortingOrder) {
					return -1;
				}
				return 0;
			});

			this.chatCategories[1].isBadgeOn = this.chatRooms.find((x) => x.unreadMessageCount > 0) ? true : false;
			document.title = this.chatCategories[0].isBadgeOn || this.chatCategories[1].isBadgeOn ? "You have new message(s)" : "V-Unite";
		},
		async getGroupMemberList(room) {
			let guid = room.guid;
			let limit = 100;
			let groupMemberRequest = new CometChat.GroupMembersRequestBuilder(guid).setLimit(limit).build();

			let allGroupMembers = [];
			do {
				var fetchAllMembers = await groupMemberRequest.fetchNext().then(
					(groupMembers) => {
						return groupMembers;
					},
					(error) => {
						this.cometChatErrorNotif(error);
						return [];
					}
				);
				allGroupMembers.push(...fetchAllMembers);
			} while (fetchAllMembers.length === limit);

			return allGroupMembers;
		},
		async getOneGroupMember(room) {
			let guid = room.guid;
			let limit = 100;
			let groupMemberRequest = new CometChat.GroupMembersRequestBuilder(guid).setLimit(limit).setSearchKeyword(this.currentUser.uid).build();

			await groupMemberRequest.fetchNext().then(
				async () => {},
				async () => {
					await this.joinToChatRoom("public", room.guid);
				}
			);
		},
		async getMessageHistory(room) {
			let id = room.guid ? room.guid : room.uid;
			let limit = 100;
			this.chatBox.noMoreMessages = false;

			this.chatBox.messagesRequest = room.guid
				? new CometChat.MessagesRequestBuilder()
						.setLimit(limit)
						.setGUID(id)
						.build()
				: new CometChat.MessagesRequestBuilder()
						.setLimit(limit)
						.setUID(id)
						.build();

			await this.chatBox.messagesRequest.fetchPrevious().then(
				async (messages) => {
					if (messages.length < this.chatBox.messagesRequest.limit) {
						this.chatBox.noMoreMessages = true;
					}
					this.chatBox.listMessages = [...messages];

					this.chatBox.loadingMessages = false;

					this.$nextTick(() => {
						this.scrollToBottom();
					});
					// Handle the list of messages
				},
				async (error) => {
					this.cometChatErrorNotif(error);
				}
			);
		},
		async loadPreviousMessages() {
			if (this.chatBox.messagesRequest) {
				await this.chatBox.messagesRequest.fetchPrevious().then(
					async (messages) => {
						if (messages.length < this.chatBox.messagesRequest.limit) {
							this.chatBox.noMoreMessages = true;
						}

						let msgFlag = this.chatBox.listMessages[0];
						this.chatBox.listMessages.splice(0, 0, ...messages);

						this.scrollToMessage(msgFlag.id);
					},
					async (error) => {
						this.cometChatErrorNotif(error);
					}
				);
			}
		},
		async sendMessage(room) {
			this.chatBox.sendingMessage = true;

			let receiverID = room.guid ? room.guid : room.uid;
			let messageText = this.chatBox.chatMessage;
			let receiverType = room.guid ? CometChat.RECEIVER_TYPE.GROUP : CometChat.RECEIVER_TYPE.USER;

			let textMessage = new CometChat.TextMessage(receiverID, messageText, receiverType);

			let metadata = {
				pushNotification: "Your Notification Message"
			};
			textMessage.setMetadata(metadata);

			await CometChat.sendMessage(textMessage).then(
				async (message) => {
					this.$refs.messageForm.reset();
					this.chatBox.sendingMessage = false;

					await this.getMessageHistory(room);
					this.$nextTick(() => {
						this.scrollToBottom();
					});
					// to refresh sender's direct messages list
					if (room.uid) {
						let notExist = true;
						for (let i of this.directMessages) {
							if (i.conversationWith.uid == room.uid) {
								// if the conversation is exist, edit the last message only (for the sender)
								i.lastMessage.text = message.text;
								i.lastMessage.sentAt = message.sentAt;
								notExist = false;
							}
						}

						if (notExist) {
							// if it isn't exist, refresh the direct message to get the new one
							await this.getDirectMessages();
						}
					}
				},
				async (error) => {
					this.cometChatErrorNotif(error);
				}
			);
		},
		async markAsRead(messageId, receiverId, receiverType) {
			await CometChat.markAsRead(messageId, receiverId, receiverType);

			await CometChat.getConversation(receiverId, receiverType).then(
				async () => {
					if (receiverType == "user") {
						await this.getDirectMessages();
					} else {
						await this.getAllChatRooms();
					}
				},
				async (error) => {
					this.cometChatErrorNotif(error);
				}
			);
		},
		async getUnreadMessageCount(type, id) {
			if (type == "user") {
				await CometChat.getUnreadMessageCountForUser(id).then(
					(array) => {
						console.log("Unread Message count fetched (for user)", array);
					},
					(error) => {
						this.cometChatErrorNotif(error);
					}
				);
			} else if (type == "group") {
				await CometChat.getUnreadMessageCountForGroup(id).then(
					(array) => {
						console.log("Unread Message count fetched (for group)", array);
					},
					(error) => {
						this.cometChatErrorNotif(error);
					}
				);
			}
		},
		async getOnlineUsers() {
			let groupId = this.groupId;
			let memberList;
			let list = [];

			this.onlineUsers = [];
			let limit = 100;
			let usersRequest = new CometChat.UsersRequestBuilder().setLimit(limit).setStatus(CometChat.USER_STATUS.ONLINE).setRole(groupId).build();

			try {
				while ((memberList = await usersRequest.fetchNext())) {
					if (memberList.length == 0) {
						break;
					} else {
						for (let i of memberList) {
							list.push(this.minimizeVisitor(i));
						}
					}
				}
			} catch (error) {
				this.cometChatErrorNotif(error);
			}
			this.onlineUsers = list;
		},
		async getAllUsers() {
			this.allUsers = [];
			let limit = 100;
			let usersRequest = new CometChat.UsersRequestBuilder()
				.setLimit(limit)
				.setSearchKeyword(this.$store.state.principal.experienceId + "-m-" + this.meetingId)
				.build();

			let unfilteredAllUsers = [];
			do {
				var fetchAllUsers = await usersRequest.fetchNext().then(
					(userList) => {
						return userList;
					},
					(error) => {
						this.cometChatErrorNotif(error);
						return null;
					}
				);

				unfilteredAllUsers.push(...fetchAllUsers);
			} while (fetchAllUsers.length === limit);

			// filtered by substring uid as a failsafe for setSearchKeyword (e.g: search for '1-' also resulting '21-' to appear)
			// (cont. note: but only for this setSearchKeyword in retrieving user, expId '21-' isn't appear, this is just in case)
			this.allUsers = unfilteredAllUsers.filter((user) => {
				return user.role != "tenant" && user.uid.substring(0, user.uid.indexOf("-")) == this.$store.state.principal.experienceId;
			});
		},
		async startCall(id, type, receiver) {
			this.call.callingProgress = true;
			let globalContext = this;

			let receiverID = id;
			let callType = type == "video" ? CometChat.CALL_TYPE.VIDEO : CometChat.CALL_TYPE.AUDIO;
			let receiverType = receiver == "user" ? CometChat.RECEIVER_TYPE.USER : CometChat.RECEIVER_TYPE.GROUP;

			let call = new CometChat.Call(receiverID, callType, receiverType);

			if (!globalContext.meetingProperties.joinedAt) {
				globalContext.meetingProperties.joinedAt = {};
			}

			CometChat.initiateCall(call).then(
				(outGoingCall) => {
					globalContext.call.caller = outGoingCall.callInitiator;
					globalContext.call.receiver = outGoingCall.callReceiver;
					globalContext.call.sessionId = outGoingCall.sessionId;
					if (receiverType == "group") {
						let tmpProperties = this.entityEditOld = this.$root.clone(this.meetingProperties);
						if (!tmpProperties.sessionId) {
							this.meetingProperties.sessionId = outGoingCall.sessionId;
							this.meetingProperties.uid = this.uid;
							this.meetingProperties.receiverType = receiverType;
							this.meetingProperties.callType = callType;
							this.meetingProperties.status = outGoingCall.status;

							this.setProperties();
						}
					}
					this.isInCall = false;
				},
				(error) => {
					this.cometChatErrorNotif(error);
				}
			);
		},
		async acceptCall() {
			let globalContext = this;
			let sessionID = globalContext.call.sessionId;

			await this.getPropeties();
			if (this.meetingProperties.receiverType == "group") {
				sessionID = this.meetingProperties.sessionId;
			}

			if (!this.meetingProperties.joinedAt) {
				this.meetingProperties.joinedAt = {};
			}

			if (!this.meetingProperties.joinedAt[this.meetingProperties.uid]) {
				let date = new Date().getTime().toString();
				this.meetingProperties.joinedAt[this.meetingProperties.uid] = date.substring(0, date.length - 3);
				this.setProperties();
			}

			this.setOnCallAccepted().then(() => {
				globalContext.call.incomingCall = false;

				CometChat.acceptCall(sessionID).then(
					(call) => {
						console.log("Call accepted successfully:", call);

						let css = ".main-tile-container-portrait {flex-direction: row;}.tile-main-video-container-portrait {flex: 1 1;height: 89%;margin: 5px 2% 5%;border-radius: 10px;}.tile-list-container-portrait {width: 15%;height: 89%;padding-left: 0;padding-right: 1%;padding-top: .5%;display: flex;align-items: center;flex-direction: column;overflow-y: auto;}.tile-container-mob {width: 90%;position: relative;aspect-ratio: 1;background-color: #000000;margin-bottom: 10px; border-radius: 0.7rem;}.thumb-mobile { width: none;height: none;margin-bottom: none;}";
						let sessionId = call.sessionId;
						let callType = call.type;
						let callSettings = new CometChat.CallSettingsBuilder()
							.setSessionID(sessionId)
							.enableDefaultLayout(true)
							.setIsAudioOnlyCall(callType == "audio" ? true : false)
							.showScreenShareButton(false)
							.setCustomCSS(css)
							.build();

						let date = new Date().getTime().toString();
						globalContext.meetingProperties.joinedAt[globalContext.uid] = date.substring(0, date.length - 3);
						globalContext.setProperties();

						CometChat.startCall(
							callSettings,
							document.getElementById("callScreen"),
							new CometChat.OngoingCallListener({
								onUserJoined: (user) => {
									/* Notification received here if another user joins the call. */
									console.log("User joined call:", user);
								},
								onUserLeft: (user) => {
									/* Notification received here if another user left the call. */
									console.log("User left call:", user);
								},
								onCallEnded: (call) => {
									/* Notification received here if current ongoing call is ended. */
									console.log("Call ended:", call);
									globalContext.call.ongoingCall = false;
									globalContext.call.incomingCall = false;
									globalContext.call.callingProgress = false;
									globalContext.call.receiverId = null;
									globalContext.call.sessionId = "";

									if (call.status == "ended") {
										if (globalContext.meetingProperties.receiverType == "group") {
											globalContext.meetingProperties.sessionId = null;
											globalContext.meetingProperties.receiverType = null;
											globalContext.meetingProperties.joinedAt = null;
											globalContext.meetingProperties.status = null;
											globalContext.setProperties();
										}
										globalContext.isInCall = false;
									}
									globalContext.checkParticipants(globalContext);
								},
								onError: (error) => {
									console.log("Call error :", error);
									globalContext.call.ongoingCall = false;
									globalContext.call.incomingCall = false;
									globalContext.call.callingProgress = false;
									globalContext.call.receiverId = null;
									globalContext.call.sessionId = "";
								}
							})
						);
					},
					(error) => {
						console.log("Call acceptance failed with error", error);
						if (error.code == "ERR_CALL_GROUP_ALREADY_JOINED") {
							let message = error.message.toString();
							let authToken = message.substring(message.indexOf("the auth token ")).replace("the auth token ", "").replace(".", "");

							this.endCall(authToken);
						} else {
							this.call.ongoingCall = false;
							this.call.incomingCall = false;
							this.call.callingProgress = false;
							this.call.receiverId = null;
							this.call.sessionId = "";
							if (error.message.includes("There is an unknown issue with the API request")) {
								error.message = "The other participant has finished the call. Please click the call button to redial";
							} else if (error.message.includes("The call with sessionId")) {
								error.message = "The call has been finished. Please click the call button to redial.";
							}
							this.cometChatErrorNotif(error);
						}
						this.getPropeties();
					}
				);
			});
		},
		async rejectCall(type) {
			let sessionID = this.call.sessionId;

			let globalContext = this;
			let status = type;

			await CometChat.rejectCall(sessionID, status).then(
				(call) => {
					console.log("Call rejected successfully", call);
					globalContext.call.incomingCall = false;
					globalContext.call.ongoingCall = false;
					globalContext.call.callingProgress = false;
					globalContext.call.receiverId = null;
					globalContext.call.sessionId = "";

					if (call.status == "cancelled" || status == "ended") {
						if (globalContext.meetingProperties.receiverType == "group") {
							globalContext.meetingProperties.sessionId = null;
							globalContext.meetingProperties.receiverType = null;
							globalContext.meetingProperties.joinedAt = null;
							globalContext.meetingProperties.status = null;
							globalContext.setProperties();
						}
						globalContext.isInCall = false;
					}
				},
				(error) => {
					console.log("Call rejection failed with error:", error);
					globalContext.call.incomingCall = false;
					globalContext.call.ongoingCall = false;
					globalContext.call.callingProgress = false;
					globalContext.call.receiverId = null;
					globalContext.call.sessionId = "";

					this.cometChatErrorNotif(error);
				}
			);
		},
		async callUser(id, type, receiver) {
			this.call.receiverId = id;
			await this.startCall(this.call.receiverId, type, receiver);
		},
		async setOnCallAccepted() {
			let globalContext = this;
			return new Promise(function (resolve, reject) {
				globalContext.call.ongoingCall = true;
				resolve();
				console.log(reject);
			});
		},
		soundSwitch() {
			axios
				.post("/system/user/edit/sound", {
					chatNotificationSound: this.chatBox.chatNotificationSound
				})
				.then(() => {})
				.catch(() => {});
		},
		notificationSound() {
			let snd = new Audio(require("./../../assets/Chatbox/notification.ogg"));
			snd.play();
		},
		profilePicture(uid) {
			this.imgError = false;
			return this.baseLocation + "/asset/file/user/" + uid + ".png?time=" + new Date().getMinutes();
		},
		setAltImg(event) {
			event.target.src = this.baseLocation + "/resource/tenant/asds/Chat.Default.Avatar.png";
		},
		resetPrivateForm() {
			if (this.$refs.privateRoomForm != undefined) {
				this.$refs.privateRoomForm.reset();
			}

			if (this.$refs.privateKickForm != undefined) {
				this.$refs.privateKickForm.reset();
			}

			if (this.$refs.privateInviteForm != undefined) {
				this.$refs.privateInviteForm.reset();
			}
		},
		removeUser(item) {
			const index = this.privateRoom.toBeJoinedUsers.indexOf(item.uid);
			if (index >= 0) this.privateRoom.toBeJoinedUsers.splice(index, 1);
		},
		cometChatErrorNotif(error) {
			let notification = {
				title: "CometChat error",
				content: {
					errorList: [error.message],
					fieldErrorList: [],
					noticeList: [],
					type: "NOTIFICATION"
				},
				withoutTitle: true
			};
			this.$store.commit("showNotification", notification);
		},
		minimizeVisitor(visitor) {
			return { uid: visitor.uid, name: visitor.name };
		},
		scrollToBottom() {
			let chat = document.getElementById("msg-page");
			if (chat != null) {
				chat.scrollTo(0, chat.scrollHeight + 30);
			}
		},
		scrollToMessage(msgId) {
			let chat = document.getElementById("msg-page");
			if (chat != null) {
				let msg = document.getElementById("msg-" + msgId);
				msg.scrollIntoView();
			}
		},
		toHexString(text) {
			let result = "";
			for (let i = 0; i < text.length; i++) {
				result += text.charCodeAt(i).toString(16);
			}

			result = this.$store.state.principal.experienceId + "-" + result;

			if (result.length > 100) {
				result = result.substring(0, 100);
			}
			return result;
		},
		formatDate(value) {
			let date = new Date(value * 1000);
			let options = {
				year: "numeric",
				month: "long",
				day: "numeric",
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit"
			};
			return date.toLocaleString("en-US", options);
		},
		onResize() {
			this.isMobile = window.matchMedia("only screen and (max-width: 599px)").matches;
		},
		toTabMenu(content) {
			this.showConversation = content == 1 ? true : false;
			this.showChat = content == 2 ? true : false;
			this.showUserOnline = content == 3 ? true : false;

			this.mobileTab = content;
		},
		getColor() {
			axios
				.post("/system/experienceColors/find", {
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug,
					page: "Conversation_Community_Networking"
				})
				.then((response) => {
					if (response.data) {
						this.color = response.data;
					}
				})
				.catch(() => {});
		},
		setProperties() {
			axios.post("/system/meeting/properties/set", {
				meetingId: this.meeting.id,
				properties: this.meetingProperties
			});
		},
		async getPropeties() {
			const response = await axios
				.post("/system/meeting/properties/get", {
					meetingId: this.meeting.id
				})
				.then((response) => response.data);
			if (response) {
				this.meetingProperties = response;
			} else {
				this.meetingProperties = {
					sessionId: null,
					receiverType: null,
					joinedAt: {}
				};
			}
		},
		async editMeeting() {
			axios.post("/system/meeting/edit", {
				meeting: this.meeting
			});
		},
		async authenticationCheck() {
			const response = await axios
				.post("/system/meeting/find", {
					id: this.meetingId
				})
				.then((response) => response.data);
			this.meeting = response;

			for (let attendee of this.meeting.attendeeList) {
				if (this.$store.state.principal.id == attendee.id) {
					this.authentication = true;
				}
			}

			if (!this.authentication) {
				if (this.$store.state.principal.id == this.meeting.creatorId) {
					this.authentication = true;
				}
			}
		},
		async endCall(authToken) {
			await this.getPropeties();
			await axios
				.post("/system/call/end", {
					sessionId: this.meetingProperties.sessionId,
					joinedAt: this.meetingProperties.joinedAt[this.uid],
					authtoken: authToken
				})
				.then((response) => {
					if (response.data) {
						this.call.ongoingCall = false;
						this.call.incomingCall = false;
						this.call.callingProgress = false;
						this.call.receiverId = null;
						this.call.sessionId = "";

						this.acceptCall();
					}
				});
		},
		checkParticipants(globalContext){
			if (globalContext.meetingProperties.sessionId && globalContext.meetingProperties.sessionId != "") {
				CometChat.getCallParticipantCount(globalContext.meetingProperties.sessionId, globalContext.meetingProperties.callType).then(
					(count) => {
						console.log("Participants count =", count);
						if (count == 0) {
							if (globalContext.meetingProperties.receiverType == "group" && globalContext.meetingProperties.status != 'initiated') {
								globalContext.meetingProperties.sessionId = null;
								globalContext.meetingProperties.receiverType = null;
								globalContext.meetingProperties.joinedAt = null;
								globalContext.meetingProperties.status = null;
								globalContext.setProperties();
							}
							globalContext.isInCall = false;
						}
					},
					(error) => {
						console.log("Some error occurred =", error);
					}
				);
			}
		}
	}
};
</script>
